module.exports = __webpack_public_path__ + "static/mother-night-604b75b25eb2651d812f430e8e4a9fc8.jpg";